// extracted by mini-css-extract-plugin
module.exports = {"icon":"modal-success_icon__2Lt6T","message":"modal-success_message__123lj"};